import {hasNonEmptyValue} from '@teladoc/fe-ccm/ui/common/utilities/has-non-empty-value';
import OneAppUserAPI from '@/user/user-oneapp-api';

/**
 * Whether the browser session has both TDOC auth and a PLI bundle identifier.
 * Matches `UserAPI.loadInitialDataForOneApp` / `OneAppUserAPI.loadInitialData`.
 * Use when syncing Redux from cookies (e.g. PersistGate onBeforeLift), not in selectors.
 */
export function getIsOneAppAuthenticatedFromSession() {
    return (
        hasNonEmptyValue(OneAppUserAPI.getTdocAuthToken()) &&
        hasNonEmptyValue(OneAppUserAPI.getBundleIdentifier())
    );
}
